import * as React from 'react';
// import { LoadingComponentProps } from "react-loadable";
import { SpinnerPage } from '@common/components';

export class LoadingSpinner extends React.Component<any> {
  render() {
    if (this.props.isLoading) {
      if (this.props.timedOut) {
        return <div>Loader timed out!</div>;
      } else if (this.props.pastDelay) {
        return <SpinnerPage />;
      } else {
        return null;
      }
    } else if (this.props.error) {
      return <div>Error! Component failed to load</div>;
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/spinner-loadable/spinner-loadable.component.tsx